<div class="slider-header">
  <h3>Requested Delivery Date View</h3>
</div>

<div class="slider-content">
<div class="col-md-12 p-0">
    <div class="fulfill-top-sec">
      <div class="row listing-action-items">
        <div class="col-sm-4" *ngIf="sraRequestDetailsDataSource?.data?.length > 0" style="padding-left: 25px !important;">
          <mat-checkbox #AllCheck class="custom-checkbox select-all-check"
                        [style.display]="'contents'"
                        [checked]="(isAllItemSelected) || sraRequestDetailsDataSource?.data?.length === selectedCount"
                        (change)="enableCheckBoxAll(AllCheck._checked)"
                        [indeterminate]="selectedCount > 0 && selectedCount < sraRequestDetailsDataSource?.data?.length"
                        [(ngModel)]="isAllItemSelected"></mat-checkbox>
          <div class="product-tools-outer" *ngIf="showTabs">
            <div class="product-tools-tab" appClickOutside (clickOutside)="tabNode=''">

              <div class="tab-bar col-md-10">
                <ul>
                  <li (click)="showTab('delivery')" class="seperator" matTooltip="Set Delivery Date" [matTooltipPosition]="'above'">
                    <i class="icon-ico-delivery"></i>
                  </li>
                </ul>
              </div>

              <div class="tab-content">
                <div *ngIf="tabNode==='delivery'" class="deliveryDate">
                  <!--<div class="tab-content-heading">
                    For: {{shipToAccountName}}
                  </div>-->
                  <div class="tab-content-detail" *ngIf="isAnyLineSMDSelected()">
                    <ngb-datepicker [(ngModel)]="datemodel" [dayTemplate]="customDay" [markDisabled]="isDisabled" ngbDatepicker #d="ngbDatepicker"></ngb-datepicker>
                    <ng-template #customDay let-date let-currentMonth="currentMonth" let-selected="selected" let-disabled="disabled" let-focused="focused">
                      <span class="custom-day" [class.weekend]="isWeekend(date)" [class.focused]="focused" [class.holiday]="isHoliday(date)"
                            [class.custom-select-day]="selected" [class.hidden]="date.month !== currentMonth" [class.text-muted]="disabled">
                        {{date.day}}
                      </span>
                    </ng-template>
                    <div class="btn-Sec " *ngIf="isAnyLineSMDSelected()">
                      <div class="row">
                        <div class="col-sm-5 col-5 pr-0">
                          <div class="pb-2">
                            <span class="white-date-box d-inline-block align-middle"></span>
                            <span class="calender-legend">
                              Today's Date
                            </span>
                          </div>
                          <div>
                            <span class="green-date-box d-inline-block align-middle"></span>
                            <span class="calender-legend">
                              Requested Delivery
                            </span>
                          </div>
                        </div>
                        <div class="col-sm-7 col-7">
                          <div class="pb-2">
                            <span class="yellow-box d-inline-block align-middle"></span>
                            <span class="calender-legend">
                              Scheduled Delivery Dates
                            </span>
                          </div>
                          <div>
                            <span class="grey-date-box d-inline-block align-middle"></span>
                            <span class="calender-legend">
                              UnScheduled Delivery Dates
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="btn-Sec text-center">
                      <button mat-raised-button class="btns normal-large-btn fullWidthBtn" color="primary" (click)="SetAllFields('deliverydate',datemodel)">Save</button>
                    </div>
                  </div>
                  <div class="tab-content-detail" *ngIf="!isAnyLineSMDSelected()">
                    <ngb-datepicker [(ngModel)]="datemodel" [dayTemplate]="customDay" [markDisabled]="isDisabled" ngbDatepicker #d="ngbDatepicker"></ngb-datepicker>
                    <ng-template #customDay let-date let-currentMonth="currentMonth" let-selected="selected" let-disabled="disabled" let-focused="focused">
                      <span class="custom-calendar-day" [class.weekend]="isWeekendForNonSDM(date)" [class.focused]="focused"
                            [class.custom-select-day]="selected" [class.hidden]="date.month !== currentMonth" [class.text-muted]="disabled">
                        {{date.day}}
                      </span>
                    </ng-template>

                    <div class="btn-Sec text-center">
                      <button mat-raised-button class="btns normal-large-btn fullWidthBtn" color="primary" (click)="SetAllFields('deliverydate',datemodel)">Save</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="ml-auto">
          <div class="display-ib wAuto">
            <mat-paginator #detailsPaginator [pageSize]="masterConstants.PAGE_SIZE" [pageSizeOptions]="masterConstants.PAGE_SIZE_OPTIONS"></mat-paginator>
          </div>
        </div>
      </div>
    </div>
    <div class="tableContainer cppSulfurZincPrincingTable priceListTable" id="sraRequestDetails">
      <table mat-table #requestDetailsTable [dataSource]="sraRequestDetailsDataSource" multiTemplateDataRows
             class="matTables">
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef class="action-column"></th>
          <td mat-cell *matCellDef="let element" class="action-column">
            <mat-checkbox #SingleCheck class="custom-checkbox"
                          [style.display]="'contents'"
                          (change)="enableCheckBoxSingle(SingleCheck._checked)"
                          [(ngModel)]="element.isSelected"></mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="account">
          <th mat-header-cell *matHeaderCellDef class="account-column"> Account </th>
          <td mat-cell *matCellDef="let element" class="account-column"> {{element.soldToAccountName}} </td>
        </ng-container>
        <ng-container matColumnDef="location">
          <th mat-header-cell *matHeaderCellDef class="account-column"> Location </th>
          <td mat-cell *matCellDef="let element" class="account-column"> {{element.shipToAccountName}} </td>
        </ng-container>
        <ng-container matColumnDef="deliveryLocation">
          <th mat-header-cell *matHeaderCellDef class="account-column"> Delivery Location </th>
          <td mat-cell *matCellDef="let element" class="account-column"> {{element.deliverToAccountName}} </td>
        </ng-container>
        <ng-container matColumnDef="manufacturer">
          <th mat-header-cell *matHeaderCellDef> Manufacturer </th>
          <td mat-cell *matCellDef="let element"> {{element.marketinBrand}} </td>
        </ng-container>
        <ng-container matColumnDef="itemNumber">
          <th mat-header-cell *matHeaderCellDef class="pb-2"> Item Number </th>
          <td mat-cell *matCellDef="let element" class="item-column"> {{element.itemNumber}} </td>
        </ng-container>
        <ng-container matColumnDef="productName">
          <th mat-header-cell *matHeaderCellDef class="pb-2">
            Product Name
            <div class="productFilters position-relative">
              <mat-form-field>
                <input matInput
                       placeholder="Product Name Filter"
                       [(ngModel)]="filteredValues.productName"
                       (ngModelChange)="filterByItemDesc($event)" />
                <button *ngIf="filteredValues.productName"
                        mat-icon-button
                        type="button"
                        class="clear-btn-input"
                        (click)="clearProductNameFilter()"
                        tabindex="-1" [disableRipple]="true">
                  <i class="fa fa-times" aria-hidden="true"></i>
                </button>
              </mat-form-field>
            </div>
          </th>
          <td mat-cell *matCellDef="let element"> {{element.productName}} </td>
        </ng-container>
        <ng-container matColumnDef="orderUOM">
          <th mat-header-cell *matHeaderCellDef> Order UOM </th>
          <td mat-cell *matCellDef="let element"> {{element.orderUOM}} </td>
        </ng-container>
        <ng-container matColumnDef="requestedQTY">
          <th mat-header-cell *matHeaderCellDef> Requested QTY </th>
          <td mat-cell *matCellDef="let element"> {{element.requestedQTY}} </td>
        </ng-container>

        <!-- Requested Arrival Date Column -->
        <!-- Requested Arrival Date Column -->
        <!-- Requested Arrival Date Column -->
        <ng-container matColumnDef="requestedArrivalDate">
          <th mat-header-cell *matHeaderCellDef class="pb-2 text-center">
            Requested Arrival Date
          </th>
          <td mat-cell *matCellDef="let element" class="text-center">
            <div class="text-center deliveryDatePicker requestDetailDate">
              <mat-form-field [class.invalid-field]="!element.requestedArrivalDate"
                              [class.ineligible-date]="element.isItemEligible === false">
                <input readonly matInput
                       (click)="openCalendar(element)"
                       [(ngModel)]="element.requestedArrivalDate"
                       placeholder="MM/DD/YYYY"
                       (dateChange)="validateDate(element, $event)"
                       [class.ineligible-text]="element.isItemEligible === false">
                <mat-icon matSuffix
                          (click)="openCalendar(element)"
                          class="calendar-day"></mat-icon>
              </mat-form-field>

              <!-- Backdrop (click to close calendar) -->
              <div class="calendar-backdrop" *ngIf="element.openDatepicker" (click)="closeCalendar(element, $event)"></div>
              <!-- Ngb Datepicker -->
              <div class="tab-content-detail" *ngIf="element.openDatepicker" #calendarContainer>
                <ngb-datepicker [(ngModel)]="requestDatemodel"
                                [startDate]="requestDatemodel"
                                [dayTemplate]="requestCustomDay"
                                [markDisabled]="isDisabled"
                                #dp="ngbDatepicker"
                                (ngModelChange)="onDateSelect(requestDatemodel, element)"
                                [minDate]="minDelDate">
                </ngb-datepicker>

                <ng-template #requestCustomDay let-date let-currentMonth="currentMonth" let-selected="selected" let-disabled="disabled" let-focused="focused">
                  <span class="custom-day" [class.weekend]="!element.isLineSDM ? true : isWeekend(date)" [class.focused]="focused" [class.holiday]="isRequestHoliday(date, element)"
                        [class.custom-select-day]="selected" [class.hidden]="date.month !== currentMonth" [class.text-muted]="disabled">
                    {{date.day}}
                  </span>
                </ng-template>

                <!-- Footer with Calendar Legend -->
                <div class="btn-Sec" *ngIf="element.isLineSDM">
                  <div class="row">
                    <div class="pl-3">
                      <div class="pb-2 text-left">
                        <span class="white-date-box d-inline-block align-middle"></span>
                        <span class="calender-legend">
                          Today's Date
                        </span>
                      </div>
                      <div>
                        <span class="green-date-box d-inline-block align-middle"></span>
                        <span class="calender-legend">
                          Requested Delivery
                        </span>
                      </div>
                    </div>
                    <div class="pl-3">
                      <div class="pb-2 text-left">
                        <span class="yellow-box d-inline-block align-middle"></span>
                        <span class="calender-legend">
                          Scheduled Delivery Dates
                        </span>
                      </div>
                      <div>
                        <span class="grey-date-box d-inline-block align-middle"></span>
                        <span class="calender-legend">
                          UnScheduled Delivery Dates
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </td>
        </ng-container>
        <!-- Arrival Date Reason Change Column -->
        <ng-container matColumnDef="arrivalDateReasonChange">
          <th mat-header-cell *matHeaderCellDef class="reasonChange text-center">
            Arrival Date Reason Change
          </th>
          <td mat-cell *matCellDef="let element" class="reasonChange">
            <div class="padding-r0" *ngIf="element.isLineSDM && element.isReasonMandatory">
              <div class="reason-dropdown material-select">
                <ng-select class="mobile-view-dropdown"
                           name="reasonChange"
                           [(ngModel)]="element.arrivalDateReasonChange"
                           [virtualScroll]="true"
                           [closeOnSelect]="true"
                           [selectOnTab]="true"
                           [clearable]="false"
                           bindValue="id"
                           (change)="reasonCodeChange(element)"
                           [searchable]="false"
                           placeholder="{{element.arrivalDateReasonChange ? '' : 'Select one'}}"
                           [ngClass]="{'reason-error-border': element.isReasonMandatory && !element.arrivalDateReasonChange}">
                  <ng-option *ngFor="let data of reasonList; let index=index" [value]="data.id">
                    <span>{{data.value}}</span>
                  </ng-option>
                </ng-select>
              </div>
            </div>
            <!--<div *ngIf="!element.isLineSDM || !element.isReasonMandatory" class="text-center">
              -
            </div>-->
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <div *ngIf="sraRequestDetailsDataSource == undefined || sraRequestDetailsDataSource?.data.length == 0"
           class="noDataMsg">
        <p>No Records found.</p>
      </div>
    </div>
  </div>

  <div class="slider-footer">
    <div class="row align-items-center">
      <div>
        <button mat-raised-button class="btns sraOrder mr-3" *ngIf="!fromPlaceOrder" [disabled]="!hasModifyItem" data-testid="ddl-save-cpp-draft" color="primary" (click)="updateRequestedDeliveryDate(false)" [style.display]="'inline-block'">Save</button>
        <button mat-raised-button *ngIf="fromPlaceOrder" [disabled]="disableContinueBtn()" class="btns sraOrder" data-testid="ddl-save-cpp-draft" color="primary" (click)="updateRequestedDeliveryDate(true)"  [style.display]="'inline-block'">Continue</button>
      </div>
      <div class="ml-auto">
        <span class="count">Records Selected<span>{{selectedCount}}</span></span>
      </div>
    </div>
  </div>
</div>
